module.exports = __webpack_public_path__ + "img/qeustion.202993c9.png";